import clsx from "clsx";
import { useForm as useFormHook } from "hooks";
import {
    FormField,
    type OnboardingPaymentMethods,
    type OnboardingPaymentMethodsForm
} from "./types";
import useValidationSchema from "./useValidationSchema";

export const getInitialValues = ({
    otherMethods,
    methods = [],
}: Partial<OnboardingPaymentMethods>
): OnboardingPaymentMethods => ({
    [FormField.Methods]: methods,
    [FormField.OtherMethods]: clsx(otherMethods),
});

export const useForm = (onboardingPaymentMethods: OnboardingPaymentMethodsForm) =>
    useFormHook({
        isInitialValid: false,
        ...onboardingPaymentMethods,
        validateOnMount: true,
        validationSchema: useValidationSchema()
    });
